export const ENABLE_WAITING = 'enableWaiting'
export const DISABLE_WAITING = 'disableWaiting'
export const OPEN_DELETE_DIALOG = 'openDeleteDialog'
export const UPDATE_DELETE_DIALOG = 'updateDeleteDialog'
export const CLOSE_DELETE_DIALOG = 'closeDeleteDialog'
export const GET_COUNTRIES = 'getCountries'
export const SET_COUNTRIES = 'setCountries'
export const LOG_UTM = 'logUtm'
